import React, {useEffect, useState} from 'react';
import moment from "moment";
import {Box, Grid, Paper, Table, TableBody, TableContainer, Typography, Button, TableHead, TableRow, TableCell} from "@mui/material";
import DateRangePickerComponent from "../../common/CustomDateRangePicker";
import ReportRowData from "./report-row-data.component";
import ReactSelect from "react-select";
import useReportLogs from '../../../hooks/useReportLogs';
import ReportLogListSkeleton from "./skeleton/report-logs-list.skeleton";
import CachedIcon from "@mui/icons-material/Cached";

const reportLogsTableHeaders = [
    {label: "Report Type"},
    {label: "Generated By"},
    {label: "Date Range Start"},
    {label: "Date Range End"},
    {label: "Status"},
    {label: "Actions"}
]

const ReportLogsListComponent = (props) => {

    const {getUserEmail, emailList} = props;

    const {isSearchingGeneratedBy, isFetchingReportLogs, reportLogsList, isFilterByStatus, reportLogsListByStatus,
        reportLogsListByGeneratedBy, listReportLogs, listReportLogsByGeneratedBy, listReportLogsByStatus, listReportLogsByGeneratedByAndStatus
    } = useReportLogs();

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [searchedGeneratedBy, setSearchedGeneratedBy] = useState(" ");
    const [emailSearchedValue, setEmailSearchedValue] = useState(null);

    const [filterLabel, setFilterLabel] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    const [formattedEmailList, setFormattedEmailList] = useState([]);

    useEffect(() => { 
        getUserEmail();
    }, [])
    
    useEffect(() => {
        if (!emailSearchedValue && (!filterLabel || filterLabel == undefined) && startDate && endDate) {
            let report_type = 3;

            listReportLogs(startDate, endDate, report_type);

        } else if (emailSearchedValue && !filterLabel) {
            let report_type = 5;

            listReportLogsByGeneratedBy(startDate, endDate, report_type, emailSearchedValue);

        } else if (!emailSearchedValue && filterLabel) {
            let report_type = 7;

            listReportLogsByStatus(startDate, endDate, report_type, filterLabel);

        } else if (emailSearchedValue && filterLabel) {
            let report_type = 6;

            listReportLogsByGeneratedByAndStatus(startDate, endDate, report_type, emailSearchedValue, filterLabel);
        }
    }, [startDate, endDate, emailSearchedValue, filterLabel])

    useEffect(() => {
        if (emailList) {
            const formattedList = emailList?.map(email => ({
                label: email.user_email,
                value: email.user_email
            }));

            setFormattedEmailList(formattedList);
        }
    }, [emailList])

    
    const filterStyles = {
        control: (styles, { isFocused }) => ({
            ...styles,
            textAlign: "left",
            backgroundColor: "#fff",
            minHeight: 20,
            padding: "0 8px",
            height: 33, 
            width: 250,
            fontSize: 14,
            borderColor: "rgb(122, 120, 247)",
            '&:hover': {
                borderColor: "rgb(122, 120, 247)", 
            },

        }),
        valueContainer: (styles) => ({
            ...styles,
            padding: "0px 6px", 
        }),
        input: (styles) => ({
            ...styles,
            margin: 0, 
            padding: 0,
        }),
        option: (styles) => ({...styles, textAlign: "left", fontSize: 13}),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: "rgb(122, 120, 247)", 
            marginTop: "-2px",
            '&:hover': {
                color: "rgb(122, 120, 247)",
            },
        }),
        clearIndicator: (styles) => ({
            ...styles,
            color: "rgb(122, 120, 247)", 
            marginTop: "-2px",
            '&:hover': {
                color: "rgb(122, 120, 247)", 
            },
        }),
        singleValue: (styles) => ({
            ...styles,
            color: "rgba(51, 51, 207, 0.808)",
            marginTop: "-3px",
            fontSize: 13,
        }),
        placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "-3px", fontSize: 12}), 
        menuPortal: provided => ({...provided, zIndex: 9999}),
        menu: provided => ({...provided, zIndex: 9999}),
        noOptionsMessage: (provided) => ({
            ...provided,
            fontStyle: "italic", 
            textAlign: "start", 
            fontSize: "13px", 
        }),
    }

    let statusOptions = [
        {value: "completed", label: "Completed"},
        {value: "ongoing", label: "Ongoing"},
        {value: "error", label: "Error"}
    ]

    const handleSelectStatus = (selectedOption) => {
        setSelectedStatus(selectedOption);
        setFilterLabel(selectedOption?.label);
    }
    
    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleSearchGeneratedBy = (selectedOption) => {
        if (!selectedOption) {
            setSearchedGeneratedBy(" ");
            setEmailSearchedValue(null);

        } else {
            setSearchedGeneratedBy(selectedOption);
            setEmailSearchedValue(selectedOption?.value);
        }
    }

    const handleClearFilters = (e) => {
        setSearchedGeneratedBy("");
        setFilterLabel("");
        setSelectedStatus("");
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }

    const renderNoResults = (message) => (
        <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}}>
            <TableCell colSpan={6} align="center">
                <Typography sx={{fontSize: 16, color: "#58565f", padding: "40px 40px 20px 40px"}}>
                    {message}
                </Typography>
            </TableCell>
        </TableRow>
    )
    

    return (
        <Box>
            <Box sx={{mt: 3}}>
                <Grid container>
                    <Grid item xs={3}>
                        <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                            startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                        >
                            Clear Filters
                        </Button>
                    </Grid>

                    <Grid item xs={9} sx={{display: "flex", justifyContent: "flex-end", ml: "auto"}}>
                        <ReactSelect
                            isRtl={false}
                            options={formattedEmailList}
                            value={searchedGeneratedBy}
                            onChange={selectedOption => handleSearchGeneratedBy(selectedOption)}
                            styles={filterStyles}
                            isClearable={true}
                            placeholder={(searchedGeneratedBy != " ") ? null : "Select Generated By"}
                            noOptionsMessage={() => "No matching email found."} 
                            menuPortalTarget={document.body} 
                            menuPosition="fixed"
                        />
                       
                        &nbsp;&nbsp;&nbsp;&nbsp;

                        <ReactSelect
                            className="basic-single"
                            placeholder={"Filter Status"}
                            isSearchable={false}
                            isRtl={false}
                            options={statusOptions}
                            value={(selectedStatus)}
                            onChange={selectedOption => handleSelectStatus(selectedOption)}
                            styles={filterStyles}
                            isClearable={true}
                        />

                        &nbsp;&nbsp;&nbsp;&nbsp;

                        <DateRangePickerComponent
                            initialStartDate={startDate}
                            initialEndDate={endDate}
                            ranges={{
                                "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                                "This Month": [moment().startOf('month'), moment().endOf('month')],
                                "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                            }}
                            onDateRangeChange={handleDateRangeChange}
                        />                        
                    </Grid>
                </Grid>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper} sx={{borderRadius: 2, width: "100%", mt: 2, maxHeight: 755, overflow: "auto",
                        "&::-webkit-scrollbar": {
                            width: "6px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "rgba(217, 217, 217, 0.5)"
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#7a78f7a6",
                            borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: "#7A78F7",
                            
                        }}}
                    >
                        <Table stickyHeader aria-label="sticky table" sx={{minWidth: 650}}>
                            <TableHead sx={{border: "1px solid #3333cf54"}}>
                                <TableRow>
                                    {reportLogsTableHeaders?.map((header, index) => (
                                        <TableCell key={index} sx={{ fontWeight: 700, color: '#3333CFCE', backgroundColor: "#D8D8FD", borderTop: "1px solid #7A78F7",
                                            borderBottom: "1px solid #7A78F7", borderLeft: (index === 0) ? "1px solid #7A78F7" : {}, borderTopLeftRadius: (index === 0) ? "8px" : {},
                                            borderRight: (index === 5) ? "1px solid #7A78F7" : {}, borderTopRightRadius: (index === 5) ? "2px" : {}, textAlign: (header?.label == "Last Location") ? "center" : "left" 
                                        }}>
                                            {header.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            {(isFetchingReportLogs) ?
                                <TableBody sx={{maxHeight: "calc(100vh - 300px)", overflowY: "auto"}}>
                                    <ReportLogListSkeleton />
                                
                                </TableBody>
                            :
                                <TableBody sx={{maxHeight: "calc(100vh - 300px)", overflowY: "auto"}}>
                                    {(isSearchingGeneratedBy) ? (
                                        (reportLogsListByGeneratedBy?.length > 0) ? (
                                            reportLogsListByGeneratedBy?.map((report, index) => (
                                                <ReportRowData report={report} index={index} key={index} />
                                            ))
                                        ) : (
                                            renderNoResults("No searched result (s)")
                                        )

                                    ) : (isFilterByStatus) ? (
                                            (reportLogsListByStatus?.length > 0) ? (
                                                reportLogsListByStatus?.map((report, index) => (
                                                    <ReportRowData report={report} index={index} key={index} />
                                                ))
                                            ) : (
                                                renderNoResults("No searched result (s)")
                                            )
                                    ) : (reportLogsList?.length > 0) ? (
                                            reportLogsList?.map((report, index) => (
                                                <ReportRowData report={report} index={index} key={index} />
                                            ))
                                    ) : (
                                            renderNoResults("No available data to display")
                                        )
                                    }
                                    <br />
                                </TableBody>
                            }
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ReportLogsListComponent